import {DO_CACHE_RESOURCE} from "../actions/cache";
import {createReducer} from "./index";
import * as R from 'ramda';
import moment from "moment";
import {transformations} from "./view";

const cacheInitial = {
  data: {},
};

const cacheReducer = createReducer(cacheInitial,
  {
    // 'ACTION_NAME': function (state, action) -> new_state
    [DO_CACHE_RESOURCE]: (state, action) => {
      let newState = state;
      let cachedResource = action.payload;
      cachedResource.meta = {
        loading: false,
        fetched: moment(),
        expires: moment().add(cachedResource.meta.expires, 'seconds'),
        error: null
      };
      if (!cachedResource.resource) {
        cachedResource = R.evolve(transformations, cachedResource);
        newState = R.set(R.lensPath(['data', cachedResource.id, 'resource']), cachedResource)(newState);
      } else {
        cachedResource = R.over(R.lensPath(['resource']), R.evolve(transformations))(cachedResource);
        newState = R.set(R.lensPath(['data', cachedResource.resource.id]), cachedResource)(newState);
      }
      return newState;
    },
  });

export default cacheReducer;



// WEBPACK FOOTER //
// ./src/reducers/cache.js